import { useContext, createContext, useEffect, useState } from "react";
import {useNavigate} from 'react-router-dom';
import { auth } from "./firebaseAuth";
import { setDoc, doc} from 'firebase/firestore';
import {db} from './firebaseAuth';
import { GoogleAuthProvider, onAuthStateChanged, signInWithRedirect, signOut} from "firebase/auth";

const AuthContext = createContext();

export const AuthContextProvider = ({ children}) => {

    const navigate = useNavigate();
    const [user, setUser] = useState({});
    // const [email, setEmail] = useState();
    // var [role, setRole] = useState("");
    // const [uid, setUid] = useState();    
    const role = JSON.parse(localStorage.getItem("profile"));
    const googleSignIn = () => {   
        const provider = new GoogleAuthProvider();
        if (user == null){
        // signInWithPopup(auth, provider);
        signInWithRedirect(auth, provider)
        } else{
            navigate("/");
        }            
    };

    const logOut = () => {
        signOut(auth);
        navigate('/');
    }
    
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);                
        // console.log('User', currentUser, 'Email:',currentUser.email,'Uid:', currentUser.uid);        
        // setEmail(currentUser.email);
        // setUid(currentUser.uid);
        });
        return () => {
        unsubscribe();
        };
    },[user]);
    useEffect(()=>{
        if (user != null){
            ( async()=> {
                const docRef = doc(db, `${role}`,`${user.uid}`);                
                const payload = {email:`${user.email}`};
                await setDoc(docRef, payload);
                }                
            )();
        }        
    },[user, role])
    

    return(
        <AuthContext.Provider value={{googleSignIn, logOut, user}}>
            {children}
        </AuthContext.Provider>
    );
};

export const UserAuth = () => {
    return useContext(AuthContext);
};